import { useEffect } from "react";

interface MetaOptions {
  title: string;
  description?: string;
  keywords?: string;
}

/**
 * Keeps per-page TDK in sync. The homepage TDK is owned by index.html,
 * so this hook only overrides when a page provides its own values.
 */
export default function usePageMeta({ title, description, keywords }: MetaOptions) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const setMeta = (name: string, content?: string) => {
      if (!content) return null;
      let tag = document.querySelector(`meta[name="${name}"]`);
      const created = !tag;
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      const prev = tag.getAttribute("content");
      tag.setAttribute("content", content);
      return () => {
        if (created && tag) tag.remove();
        else if (tag) tag.setAttribute("content", prev ?? "");
      };
    };

    const restoreOg = setMeta("og:title", title);
    const restoreDesc = setMeta("description", description ?? title);
    const restoreKeywords = setMeta("keywords", keywords);

    return () => {
      document.title = prevTitle;
      restoreDesc?.();
      restoreKeywords?.();
      restoreOg?.();
    };
  }, [title, description, keywords]);
}